/* eslint-disable no-shadow, @typescript-eslint/naming-convention */
import { GoalCategory, UserSurveyRole } from 'Generated/graphql-types'

export const MIN_NUM_OF_SELECTED_TEMPLATE_GOALS = 2

export const priorityCategories = [
  // Categories at the top of the list, sorted alphabetically
  ...[
    { label: 'Board Management', value: GoalCategory.BoardManagement },
    { label: 'Compliance', value: GoalCategory.Compliance },
    { label: 'Fundraising', value: GoalCategory.Fundraising },
    { label: 'Grants', value: GoalCategory.Grants },
    { label: 'Storytelling', value: GoalCategory.Storytelling },
    {
      label: 'Marketing Communications',
      value: GoalCategory.MarketingCommunications,
    },
    { label: 'People Operations', value: GoalCategory.PeopleOperations },
    {
      label: 'Strategic Planning',
      value: GoalCategory.StrategicPlanning,
    },
  ].sort((a, b) => a.label.localeCompare(b.label)),
  // Categories below always appear at the end of the list
  {
    label: 'My priority is not listed above',
    showDivider: true,
    value: GoalCategory.None,
  },
]

export const additionalPriorityCategories = [
  // 'Other' category at the top of the list
  { label: 'Other - Specify below', value: GoalCategory.Other },
  // Categories at the bottom of the list, sorted alphabetically
  ...[
    { label: 'Data & Impact', value: GoalCategory.DataImpact },
    {
      label: 'Diversity, Equity & Inclusion',
      value: GoalCategory.DeiAccessibility,
    },
    { label: 'Finance & Budgeting', value: GoalCategory.Finance },
    { label: 'Program Management', value: GoalCategory.ProgramManagement },
    { label: 'Volunteer Management', value: GoalCategory.VolunteerManagement },
  ].sort((a, b) => a.label.localeCompare(b.label)),
]

export enum NeedsAssessmentWizardStep {
  GET_STARTED = 'GET_STARTED',
  WHAT_IS_YOUR_ROLE = 'WHAT_IS_YOUR_ROLE',
  WHAT_IS_YOUR_PRIMARY_FUNCTION = 'WHAT_IS_YOUR_PRIMARY_FUNCTION',
  INVITE_YOUR_ORG_LEADER = 'INVITE_YOUR_ORG_LEADER',
  SELECT_YOUR_PRIORITIES = 'SELECT_YOUR_PRIORITIES',
  WE_HAVE_CAPTURED_YOUR_PRIORITIES = 'WE_HAVE_CAPTURED_YOUR_PRIORITIES',
  ADDITIONAL_PRIORITIES = 'ADDITIONAL_PRIORITIES',
  THANK_YOU_FOR_SHARING = 'THANK_YOU_FOR_SHARING',
  WHAT_ARE_WE_MISSING = 'WHAT_ARE_WE_MISSING',
  WE_SUGGEST_THESE_GOALS = 'WE_SUGGEST_THESE_GOALS',
  ADD_YOUR_MISSION_STATEMENT = 'ADD_YOUR_MISSION_STATEMENT',
  BASELINE_CONFIDENCE = 'BASELINE_CONFIDENCE',
  BASELINE_SUPPORT_NEEDED = 'BASELINE_SUPPORT_NEEDED',
}

export const initialOrgLeaderInvite = {
  email: '',
  firstName: '',
  lastName: '',
  emailsInvited: [] as string[],
}

export const initialPriorities = {
  firstPriority: {
    category: '' as GoalCategory,
    challenges: '',
    confidenceLevel: '',
    customPriorities: '',
    selectedGoals: [],
    updateNotes: '',
  },
  secondPriority: {
    category: '' as GoalCategory,
    challenges: '',
    confidenceLevel: '',
    customPriorities: '',
    selectedGoals: [],
    updateNotes: '',
  },
  thirdPriority: {
    category: '' as GoalCategory,
    challenges: '',
    confidenceLevel: '',
    customPriorities: '',
    selectedGoals: [],
    updateNotes: '',
  },
  missingPriority: {
    category: '' as GoalCategory,
    challenges: '',
    confidenceLevel: '',
    customPriorities: '',
    selectedGoals: [],
    updateNotes: '',
  },
}

export const orgLeaderPathRoles = [
  UserSurveyRole.OrgLeader,
  UserSurveyRole.Executive,
  UserSurveyRole.Director,
  UserSurveyRole.Manager,
]
